module.exports = __webpack_public_path__ + "static/media/founders-grotesk-web-semibold.740c9ca5.woff2";